import { createContext } from "react";

type TenantContextType = {
  tenantKey: Key;
  makerFeaturesEnabled: boolean;
} | null;

export const TenantContext = createContext<TenantContextType>(null);
